export enum CustomerType {
   EndCustomer = 'EndCustomer',
   Partner = 'Partner',
   VarCustomer = 'VarCustomer',
   ResCustomer = 'ResCustomer'
}

export namespace CustomerType {
   export function ToNumber(type: CustomerType): number {
      switch (type) {
         case CustomerType.Partner:
            return 2;
         case CustomerType.VarCustomer:
            return 3;
         case CustomerType.ResCustomer:
            return 4;
         case CustomerType.EndCustomer:
         default:
            return 1;
      }
   }

   export function FromNumber(type: number): CustomerType {
      switch (type) {
         case 2:
            return CustomerType.Partner;
         case 3:
            return CustomerType.VarCustomer;
         case 4:
            return CustomerType.ResCustomer;
         case 1:
         default:
            return CustomerType.EndCustomer;
      }
   }
}
